import React from 'react';
import QuizzesFilter from './modules/quizzes/QuizzesFilter';
import PageTemplate from './pages/Encapsulation';
import DeviceViewer from 'components/DeviceViewer';
import { ResponsiveWidth } from 'components/Css';
import PrivateRoute from '../../auth/PrivateRoute';

const DeviceViewerWithIframe = React.memo(() => (
  <DeviceViewer>
    <iframe frameBorder={0} style={{ height: 'calc(100%)', width:`${ResponsiveWidth}px` }} src='/'></iframe>
  </DeviceViewer>
));

DeviceViewerWithIframe.displayName = 'DeviceViewerWithIframe';

const registerRoutes = {
  filter: {
    path: '/quiz/filter',
    element: <PrivateRoute element={<QuizzesFilter />} />
  },
  template: {
    path: '/template',
    element: <PrivateRoute element={<DeviceViewerWithIframe />} />
  },
  home: {
    path: '/home',
    element: <PrivateRoute element={<PageTemplate />} />
  }
};

export default registerRoutes;
